import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAttachmentsDelete = {
    path: "/attachments",
    method: RouteHttpVerb.DELETE
};
export { locationRestAttachmentsDelete };
